export default __webpack_public_path__ + "static/media/Licenses_IMG-License-03.f054611c.png";